import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { FavoritesService } from './favorites.service';

@Component({
  selector: 'app-favorites',
  templateUrl: './favorites.component.html'
})

export class FavoritesComponent implements OnInit {
  private cookieData: string[] = [];
  public favorites: any = null;
  public loadingFavorites: boolean;

  constructor(
    private cookies: CookieService,
    private favoritesService: FavoritesService
  ) {}

  public ngOnInit(): void {
    this.loadingFavorites = true;
    this.getFavorites();
  }

  private getFavorites(): void {
    if (this.cookies.check('leolux_favorites')) {
      this.cookieData = JSON.parse(this.cookies.get('leolux_favorites'));
      this.favoritesService.getFavorites(this.cookieData).subscribe((res) => {
        this.favorites = res;
        this.loadingFavorites = false;
      }, () => {
        this.loadingFavorites = false;
      });
    } else {
      this.loadingFavorites = false;
    }
  }

  public resetFavorites(): void {
    this.cookieData   = [];
    this.favorites    = null;
    this.cookies.delete('leolux_favorites', '/');
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/favorites/favorites.component.ts